﻿'use strict';

var popup = require('./popup');

function change(lang) {
    window.location.href = "/Account/ChangeCurrentCulture?culture=" + lang;
};

function changeModalInit() {
    $('#languagePopupClose').on('click', function () {
        popup.close('languageWindow');
    });

    $('.js-language').on('click', function () {
        var code = $(this).attr('id');
        change(code);
    });
}

module.exports = {
    changeModalInit: changeModalInit,
    change: change
};